import { acceptedHistory } from './acceptedHistory';
import { categoryInventoryList } from './categoryInventoryList';
import { categoryList } from './categoryList';
import getByType from './getByType';
import { getInventoryStatus } from './getInventoryStatus';
import { inventoryOperate } from './inventoryOperate';
import { queryAllInventoryCategory } from './queryAllInventoryCategory';
import { queryInventoryRule } from './queryInventoryRule';
import { subStrategyList } from './subStrategyList';

export default {
  acceptedHistory,
  categoryInventoryList,
  categoryList,
  getByType,
  getInventoryStatus,
  inventoryOperate,
  queryAllInventoryCategory,
  queryInventoryRule,
  subStrategyList,
};
